import { useEffect, useRef } from 'react'
import classNames from 'classnames'

import { getImageUrl } from '../../../utils'
import styles from './CountryCard.module.scss'
import useIsMobile from '../../../hooks/useIsMobile'

const CountryCard = ({ countryData = [], index }) => {
  let animationRef = useRef(null)
  const isMobile = useIsMobile()

  useEffect(() => {
    if (animationRef?.current) {
      const numOfCountries = countryData.length
      let animationDuration = numOfCountries * 8
      let animationKeyframes = ''
      const styleSheet = document.styleSheets[0]
      if (index % 2 === 0) {
        let startTransform = ''
        let midTransform = ''
        if (isMobile) {
          startTransform =
            numOfCountries < 3 ? '20' : `${-5 - numOfCountries * 5.5}`
          midTransform =
            numOfCountries < 3 ? '90' : `${100 - numOfCountries * 4}`
        } else {
          startTransform =
            numOfCountries <= 3 ? '10' : `${10 - numOfCountries * 7.5}`
          midTransform =
            numOfCountries <= 3 ? '140' : `${140 - numOfCountries * 3}`
        }
        animationKeyframes = `@keyframes box-even { 0% { transform: translateX(${startTransform}%); } 50% { transform: translateX(calc(${midTransform}% - 100vw)); } 100% { transform: translateX(${startTransform}%); } }`
        if (styleSheet) {
          styleSheet.insertRule(animationKeyframes, styleSheet.cssRules.length)
        }
        // console.log(document.styleSheets[0], styleSheet)
        animationRef.current.style.animation = `box-even ${animationDuration}s linear infinite`
      } else {
        let startTransform = ''
        let midTransform = ''
        if (isMobile) {
          startTransform =
            numOfCountries < 3 ? '-20' : `${5 + numOfCountries * 6}`
          midTransform =
            numOfCountries < 3 ? '-90' : `${-100 + numOfCountries * 4}`
        } else {
          startTransform =
            numOfCountries <= 3 ? '-10' : `${-10 + numOfCountries * 9}`
          midTransform =
            numOfCountries <= 3 ? '-140' : `${-140 - numOfCountries * 2}`
        }
        animationKeyframes = `@keyframes box-odd { 0% { transform: translateX(${startTransform}%); } 50% { transform: translateX(calc(${midTransform}% + 100vw)); } 100% { transform: translateX(${startTransform}%); } }`
        if (styleSheet) {
          styleSheet.insertRule(animationKeyframes, styleSheet.cssRules.length)
        }
        // console.log(document.styleSheets[0], styleSheet)
        animationRef.current.style.animation = `box-odd ${animationDuration}s linear infinite`
      }
    }
  }, [countryData, index, isMobile])

  return (
    <div
      className={classNames(styles['no-scrollbar'], {
        [styles.evenCard]: index % 2 === 0,
        [styles.oddCard]: index % 2 !== 0,
      })}
    >
      <div ref={animationRef} className={styles.box}>
        {countryData?.map((country) => (
          <div
            className={classNames(
              styles['country-card'],
              'flex flex-row items-center ',
              !country?.country_logo ? styles['country-no-bg'] : ''
            )}
            key={'country' + country?.id}
          >
            {country?.country_logo && (
              <img
                src={getImageUrl(country?.country_logo)}
                alt={country?.country_logo?.alternativeText}
                className={styles.flag}
              />
            )}
            <div className={styles.countryName}>
              {country?.country_name}
              {country.e_commerce && (
                <>
                  <br />
                  {countryData.subTitle}
                </>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default CountryCard
